module.exports = __webpack_public_path__ + "static/media/engine-fan_red_1.9e6926bd.png";